













































import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  AppHtmlRender,
  AppCardDescriptionBlockLayout,
  AppTypeIcon,
  AppHeading,
} from '@/uikit';

@Component({
  components: {
    AppHeading,
    AppTypeIcon,
    AppHtmlRender,
    AppCardDescriptionBlockLayout,
  },

  inheritAttrs: false,
})
export default class ProfessionInfo extends Vue {
  @Prop({ type: String, default: '' })
  readonly description!: string;

  @Prop({ type: String, default: '' })
  readonly qualitiesDesc!: string;

  @Prop({ type: String, default: '' })
  readonly interestsDesc!: string;

  @Prop({ type: String, default: '' })
  readonly contraindicationsDesc!: string;
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/professions/card/info/ProfessionInfo.vue